import React, { useState } from 'react';

import ShareOutlinedIcon from '@mui/icons-material/ShareOutlined';
import { Button, IconButton, Tooltip } from '@mui/material';

import { useGetBrowsableLensSpaces } from '~/hooks/apis/reporting/useLensSpaces';
import useCurrentUser from '~/hooks/useCurrentUser';

import type { LensResponse } from '~/types/leLens';

import ShareLensDialog from '../ShareLensDialog';

import type { LensState } from './types';

type LensShareProps = {
  detail: LensResponse;
  state: LensState;
  narrow: boolean;
  publishingDisabled?: boolean;
};

export default function LensShare({ detail, state, narrow, publishingDisabled }: LensShareProps) {
  const { lens, access } = detail;
  const [dialog, setDialog] = useState(false);
  const { user } = useCurrentUser();
  const spaces = useGetBrowsableLensSpaces(dialog);

  return (
    <>
      {narrow ? (
        <Tooltip title="Share">
          <IconButton aria-haspopup="dialog" aria-label="Share" onClick={() => setDialog(true)} size="small">
            <ShareOutlinedIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      ) : (
        <Button
          aria-haspopup="dialog"
          onClick={() => setDialog(true)}
          size="small"
          startIcon={<ShareOutlinedIcon fontSize="small" />}
          sx={{ whiteSpace: 'nowrap' }}
          variant="outlined"
        >
          Share
        </Button>
      )}
      {dialog ? (
        <ShareLensDialog
          documentState={state}
          publishingDisabled={publishingDisabled}
          lens={{
            ...lens,
            access: {
              role: null,
              canRead: true,
              canPropose: false,
              canReview: false,
              canRestore: false,
              canShare: false,
              canRequestCertification: false,
              canCertify: false,
              canRemoveCertification: false,
              ...access,
            },
            home: detail.sharing?.home ?? lens.home,
            audience: detail.sharing?.audience ?? lens.audience,
          }}
          onClose={() => setDialog(false)}
          open
          spaces={spaces.data?.spaces ?? []}
          spacesError={spaces.isError}
          spacesLoading={spaces.isLoading}
          viewerEmail={user?.email}
        />
      ) : null}
    </>
  );
}
